/*
 * @Description:校验规则
 * @Author: WangYuhan
 * @Date: 2022-11-01 16:43:01
 * @LastEditTime: 2023-10-19 17:35:57
 * @LastEditors: WangYuhan
 */

// 手机号验证
export function valiPhone(phone) {
  if (/^1\d{10}$/.test(phone)) {
    return true;
  } else {
    return false;
  }
}

// 中文姓名
export function valiName(phone) {
  if (/^(?:[\u4e00-\u9fa5·]+)$/.test(phone)) {
    return true;
  } else {
    return false;
  }
}

// 邮政编码认证
export function postalCode(val) {
  const reg = /^(0[1-7]|1[0-356]|2[0-7]|3[0-6]|4[0-7]|5[1-7]|6[1-7]|7[0-5]|8[013-6])\d{4}$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 数字验证，带长度验证，不传代表不限长度
export function valiNum(val, num) {
  const reg = num ? new RegExp(`^([0-9]{0,${num}})$`, 'g') : new RegExp('^([0-9]{0,})$');
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 数字+字母验证，带长度验证，不传代表不限长度，考虑纯数字纯字母
export function valiNumLetter(val, num) {
  // (?![0-9]+$)(?![a-zA-Z]+$)
  const reg = num
    ? new RegExp(`^([0-9a-zA-Z]{0,${num}})$`, 'g')
    : new RegExp('^([0-9a-zA-Z]{0,})$');
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 短信验证码
export function valiCode(phone) {
  if (/^\d{6}$/.test(phone) || /^\d{4}$/.test(phone)) {
    return true;
  } else {
    return false;
  }
}

export function valicomanyName(val) {
  // (?![0-9]+$)(?![a-zA-Z]+$)
  const reg = /^[\u4e00-\u9fa5\uFF00-\uFFFF()()\da-zA-Z]{2,64}$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 用户名
export function valiuserName(val) {
  // (?![0-9]+$)(?![a-zA-Z]+$)
  const reg = /^[0-9a-zA-Z\u4e00-\u9fa5]{2,64}$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

export function valiuserPassword(value) {
  // 规则1: 长度8-16位
  if (value.length < 8 || value.length > 16) {
    return false;
  }

  // 规则2: 包含两种及以上字符类型
  const hasNumber = /[0-9]/.test(value);
  const hasLower = /[a-z]/.test(value);
  const hasUpper = /[A-Z]/.test(value);
  const hasSpecial = /[!@#$%^&*()_+.]/.test(value);
  const typeCount = [hasNumber, hasLower, hasUpper, hasSpecial].filter(Boolean).length;
  if (typeCount < 2) {
    return false;
  } else {
    return true;
  }
}

// 用户密码
export function valiPass(val) {
  // (?![0-9]+$)(?![a-zA-Z]+$)
  const reg = /^[0-9a-zA-Z_]{6,18}$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 车牌号正则
export function validPlateNum(plateNum) {
  var plateNumReg =
    /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z].{5,6}$/;
  if (plateNumReg.test(plateNum)) {
    return true;
  } else {
    return false;
  }
}

// 中国大陆车牌号正则
export function validPlateNumChina(rule, value, callback) {
  rule = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z].{5,6}$/;
  if (!value) {
    callback(new Error('请输入车牌号'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的车牌号'));
  } else {
    callback();
  }
}

// 发票号码：由8位阿拉伯数字组成
export function validInvoiceNum(invoiceNum) {
  var invoiceNumReg = /\d{8}/;
  if (invoiceNumReg.test(invoiceNum)) {
    return true;
  } else {
    return false;
  }
}

// 座机验证
export function valiPhoneFixed(phone) {
  if (/^\d{3,4}-\d{7,8}$/.test(phone)) {
    return true;
  } else {
    return false;
  }
}

// 手机或者座机验证
export function valiPhoneText(phone) {
  return /^1\d{10}$/.test(phone);
}
// 打款金额
export function valiaMount(rule, value, callback) {
  rule = /(^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d{1,2})?$)/;
  if (!value) {
    callback(new Error('请输入您的打款金额'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的打款金额'));
  } else {
    callback();
  }
}

export function vehicleNum(rule, value, callback) {
  rule = /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z].{5,6}$/;
  if (!value) {
    callback(new Error('请输入车牌号'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的车牌号'));
  } else {
    callback();
  }
}
// 姓名
export function validaIteName(rule, value, callback) {
  rule = /^[0-9a-zA-Z\u4e00-\u9fa5]{2,50}$/;
  if (!value) {
    callback(new Error('请输入姓名'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的姓名'));
  } else {
    callback();
  }
}

// 手机号
export function validaItePhone(rule, value, callback) {
  rule = /^1\d{10}$/;
  if (!value) {
    callback(new Error('请输入手机号'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的手机号'));
  } else {
    callback();
  }
}

// 身份证号码
export function validateIdCrad(rule, value, callback) {
  rule = [
    /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
    /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/,
  ];
  if (!value) {
    callback(new Error('请输入身份证号'));
  }
  if (value) {
    if (value.length == 18) {
      if (!rule[0].test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    } else if (value.length == 15) {
      if (!rule[1].test(value)) {
        callback(new Error('请输入正确的身份证号'));
      } else {
        callback();
      }
    } else {
      callback(new Error('请输入正确的身份证号'));
    }
  }
}

// 社会统一信用代码
export function validatecreditCode(rule, value, callback) {
  rule = /^[0-9a-zA-Z]{18}$/;
  if (!value) {
    callback(new Error('请输入企业统一社会信用代码'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的企业统一社会信用代码'));
  } else {
    callback();
  }
}

// 企业名称
export function validaIteCompName(rule, value, callback) {
  rule = /^[\u4e00-\u9fa5\uFF00-\uFFFF()()]{2,100}$/;
  if (!value) {
    callback(new Error('请输入企业全称'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的企业全称'));
  } else {
    callback();
  }
}

// 开户行总称
export function validateBankName(rule, value, callback) {
  rule = /^[\u4e00-\u9fa5\uFF00-\uFFFF()()\da-zA-Z0-9]{4,100}$/;
  if (!value) {
    callback(new Error('请输入开户行行名称'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入开户行的总行名称'));
  } else {
    callback();
  }
}

// 银行账户
export function validateCardNo(rule, value, callback) {
  rule = /^\d+$/;
  if (!value) {
    callback(new Error('请输入您的银行账户'));
  }
  if (!rule.test(value)) {
    callback(new Error('请输入正确的银行账户'));
  } else {
    callback();
  }
}

export function codeName(val) {
  const reg = /^[\u4e00-\u9fa5\uFF00-\uFFFF()()]{2,100}$/;
  if (reg.test(val)) {
    return true;
  } else {
    return false;
  }
}

// 打款金额
export function valiaImg(rule, value, callback) {
  if (!value) {
    callback(new Error('请上传正确图片'));
  } else {
    callback();
  }
}

// 运单装货正则
export function validaIteStart(rule, value, callback) {
  const str1 = value ? value.split(' ')[0] : '';
  const str2 = value ? value.split(' ')[1] : '';
  rule =
    /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
  if (!value) {
    callback(new Error('请选择装货日期及时间'));
  }
  if (!rule.test(value)) {
    callback(new Error('请选择装货日期及时间'));
  } else {
    callback();
  }
}

// 运单卸货正则
export function validaIteEnd(rule, value, callback) {
  const str1 = value ? value.split(' ')[0] : '';
  const str2 = value ? value.split(' ')[1] : '';
  rule =
    /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/;
  if (!value) {
    callback(new Error('请选择卸货日期及时间'));
  }
  if (!rule.test(value)) {
    callback(new Error('请选择卸货日期及时间'));
  } else {
    callback();
  }
}
export function validatePasswordNew(rule, value, callback) {
  // 规则1: 长度8-16位
  if (value.length < 8 || value.length > 16) {
    callback(new Error('密码长度需为8~16位'));
  }

  // 规则2: 包含两种及以上字符类型
  const hasNumber = /[0-9]/.test(value);
  const hasLower = /[a-z]/.test(value);
  const hasUpper = /[A-Z]/.test(value);
  const hasSpecial = /[!@#$%^&*()_+.]/.test(value);
  const typeCount = [hasNumber, hasLower, hasUpper, hasSpecial].filter(Boolean).length;
  if (typeCount < 2) {
    callback(
      new Error('密码需包含数字、大写字母、小写字母、特殊字符(!@#$%^&*()_+.)中的两种及以上'),
    );
  } else {
    callback();
  }
}
